import { styled, makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const courseHeight = 168

const useStyles = makeStyles((theme, image) => ({
  course: {
    background: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    border: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      height: courseHeight,
      transition: 'box-shadow 0.3s ease-in-out',

      '&:hover': {
        boxShadow: theme.palette.shadow.cardBoxShadow,
      },
    },
  },
  location: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  address: {
    width: '100%',
  },
  link: {
    color: theme.palette.common.black,
  },
  icon: {
    float: 'left',
    marginLeft: -6,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: `${theme.spacing(3)}px`,

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      height: courseHeight,
      width: '100%',
      // padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`,
    },
  },
  image: {
    backgroundImage: `url(${image})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '162px',

    [theme.breakpoints.up('sm')]: {
      maxHeight: '100%',
      maxWidth: courseHeight,
      height: '100%',
    },
  },
  col: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    border: 'none',
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      justifyContent: 'space-between',
    },
  },
  ctaCol: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  ctaWithImage: {
    borderTop: 0,
    borderLeft: 0,
    marginTop: 50,
    paddingTop: 0,
    [theme.breakpoints.up('sm')]: {
      width: '15%',
    },
  },
}))

export default useStyles


export const CourseContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    height: courseHeight,
    width: '100%',
  },
}))

export const CourseColBox = styled(Box)(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  border: 'none',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'space-between',
  },
}))

export const ImageContainer = styled(Box)(({ theme, image }) => ({
  backgroundImage: `url(${image})`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  height: '162px',

  [theme.breakpoints.up('sm')]: {
    maxHeight: '100%',
    maxWidth: courseHeight,
    height: '100%',
  },
}))

export const CourseCtaBox = styled(Box)(({ theme, image }) => ({
  alignItems: 'flex-end',
  display: 'flex',
  border: '0',
  borderTop: image ? '0' : `1px solid ${theme.palette.grey[300]}`,
  justifyContent: 'flex-end',
  marginTop: image ? '50px' : '190px',
  paddingTop: image ? '0' : '15px',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    borderTop: '0',
    borderLeft: image ? '0' : `1px solid ${theme.palette.grey[300]}`,
    marginTop: '0',
    marginBottom: '8px',
    width: image ? '15%' : '160px',
  },
}))
